module.exports = __webpack_public_path__ + "img/hito001.5c835641.webp";